import LineosoftBackground from "assets/contactImage.jpg";
import LineosoftADD2 from "assets/LineosoftADD (2)-min.PNG";
import LineosoftArticleAdd from "assets/LineosoftArticleAdd-min.PNG";
import LineosoftArticleDashboard from "assets/LineosoftArticleDashboard-min.PNG";
import LineosoftArticleListing from "assets/LineosoftArticleListing-min.PNG";
import LineosoftArticleListing2 from "assets/LineosoftArticleListing2-min.PNG";
import LineosoftArticleListing3 from "assets/LineosoftArticleListing3-min.PNG";
import LineosoftMenuAndSettings from "assets/LineosoftMenuAndSettings (2)-min.PNG";
import MetafightWelcome from "assets/MetafightWelcome-min.png";
import MetafightLeague from "assets/MetafightLeague-min.png";
import MetafightGetStarted from "assets/MetafightGetStarted-min.png";
import MetafightParticipate from "assets/MetafightParticipate-min.png";
import MetafightSemiFinal from "assets/MetafightSemiFinal-min.png";
import MetafightWinner from "assets/MetafightWinner-min.png";
import OldPortfolio from "assets/OldPortfolio-min.PNG";
import Planty from "assets/planty-min.png";
import Seabex from "assets/SEABEX.jpg";
import SodebsWin from "assets/Sodebs1-min.PNG";
import backgroundSprPlaceholder from 'assets/spr-background-placeholder.jpg';
import imageSprLessonBuilderDarkPlaceholder from 'assets/spr-lesson-builder-dark-placeholder.jpg';
import imageSprLessonBuilderLightPlaceholder from 'assets/spr-lesson-builder-light-placeholder.jpg';
import volkiharSlidePlaceholder from 'assets/volkihar-slide-placeholder.jpg';
import Footer from 'components/Footer';
import {
  ProjectBackground, ProjectContainer, ProjectHeader, ProjectImage, ProjectSection,
  ProjectSectionContent,
  ProjectTextRow
} from 'components/ProjectLayout';
import SegmentedControl, { SegmentedControlOption } from 'components/SegmentedControl';
import { useTheme } from 'components/ThemeProvider';
import { useAppContext, useScrollRestore } from 'hooks';
import { Fragment, lazy, Suspense, useMemo } from 'react';
import { Helmet } from 'react-helmet';
import prerender from 'utils/prerender';
import { media } from 'utils/style';
import './index.css';



const title = 'Web Projects';
const description =
  'Overview of my personal and professionals web applications';

const sodebsRoles = ["Progressive web app", "VanillaJs / HTML / Sass", "ReactJs", "NodeJs and Firebase",];

const ProjectSPR = () => {
  const Carousel = lazy(() => import('components/Carousel'));
  const { themeId } = useTheme();
  const { dispatch } = useAppContext();
  useScrollRestore();

  const isDark = themeId === 'dark';
  const themes = ['dark', 'light'];

  const handleThemeChange = index => {
    dispatch({ type: 'setTheme', value: themes[index] });
  };

  return (

    <Fragment>
      <ProjectContainer className="spr">
        <Helmet>
          <title>{`Projects | ${title}`}</title>
          <meta name="description" content={description} />
        </Helmet>
        <ProjectBackground
          opacity={isDark ? 0.5 : 0.8}
          srcSet={`${LineosoftBackground} 1080w, ${LineosoftBackground} 2160w`}
          placeholder={backgroundSprPlaceholder}
          entered={!prerender}
        />
        <ProjectHeader
          title={"Lineosoft"}
          description={'Lineosoft is a platform for store management. It includes a front office, which is a cash register system for storekeepers. A back office for the store manager to manage billings, articles, stock, suppliers and users. A second back office for Lineosoft software distributors for managing licenses per store.'}
          url="http://196.179.226.74:8995/#/login"
          roles={[
            'ReactJs',
            'Material UI',
            'Context API',
            'Docker',
          ]}
        />
          {/* first props for enabling class => padding-bottom: 0; */}
        <ProjectSection first>
          <ProjectSectionContent className="volkihar__carousel">
            <Suspense fallback={null}>
              <Carousel
                placeholder={volkiharSlidePlaceholder}
                images={useMemo(
                  () => [
                    {
                      src: LineosoftArticleDashboard,
                      srcSet: `${LineosoftArticleDashboard} 960w, ${LineosoftArticleDashboard} 1920w`,
                      alt: 'Lineosoft React.js Dashboard',
                    },
                    {
                      src: LineosoftArticleListing,
                      srcSet: `${LineosoftArticleListing} 960w, ${LineosoftArticleListing} 1920w`,
                      alt: 'Lineosoft React.js Listing',
                    },
                    {
                      src: LineosoftArticleListing2,
                      srcSet: `${LineosoftArticleListing2} 960w, ${LineosoftArticleListing2} 1920w`,
                      alt: 'Lineosoft React.js Listing',
                    },
                    {
                      src: LineosoftArticleListing3,
                      srcSet: `${LineosoftArticleListing3} 960w, ${LineosoftArticleListing3} 1920w`,
                      alt: 'Lineosoft React.js Listing',
                    },
                    {
                      src: LineosoftArticleAdd,
                      srcSet: `${LineosoftArticleAdd} 960w, ${LineosoftArticleAdd} 1920w`,
                      alt: 'Lineosoft React.js Listing',
                    },
                    {
                      src: LineosoftADD2,
                      srcSet: `${LineosoftADD2} 960w, ${LineosoftADD2} 1920w`,
                      alt: 'Lineosoft React.js Listing',
                    },
                    {
                      src: LineosoftMenuAndSettings,
                      srcSet: `${LineosoftMenuAndSettings} 960w, ${LineosoftMenuAndSettings} 1920w`,
                      alt: 'Lineosoft React.js Listing',
                    },
                  ],
                  []
                )}
                width={1431}
                height={806}
              />
            </Suspense>
          </ProjectSectionContent>
        </ProjectSection>

        <ProjectHeader
          title={"Metafight"}
          description={'Metafight is decentralized application on top of Ternoa Blockchain where professional MMA fighters are NFT cards. Each player can participate in daily, weekly and monthly tournament and win prizes. There is also quests challenge to win cage fragments and participate in the cage event.'}
          url="https://app.metafight.com/"
          roles={[
            'NextJs',
            'TailwindCSS',
            'Redux',
            'Vercel',
            'Figma'
          ]}
        />
      
        <ProjectSection >
          <ProjectSectionContent className="volkihar__carousel">
            <Suspense fallback={null}>
              <Carousel
                placeholder={volkiharSlidePlaceholder}
                images={useMemo(
                  () => [
                    {
                      src: MetafightWelcome,
                      srcSet: `${MetafightWelcome} 960w, ${MetafightWelcome} 1920w`,
                      alt: 'Metafight NextJs Welcome',
                    },
                    {
                      src: MetafightGetStarted,
                      srcSet: `${MetafightGetStarted} 960w, ${MetafightGetStarted} 1920w`,
                      alt: 'Lineosoft React.js Listing',
                    },
                    {
                      src: MetafightLeague,
                      srcSet: `${MetafightLeague} 960w, ${MetafightLeague} 1920w`,
                      alt: 'Lineosoft React.js Listing',
                    },
                    {
                      src: MetafightParticipate,
                      srcSet: `${MetafightParticipate} 960w, ${MetafightParticipate} 1920w`,
                      alt: 'Lineosoft React.js Listing',
                    },
                    {
                      src: MetafightSemiFinal,
                      srcSet: `${MetafightSemiFinal} 960w, ${MetafightSemiFinal} 1920w`,
                      alt: 'Lineosoft React.js Listing',
                    },
                    {
                      src: MetafightWinner,
                      srcSet: `${MetafightWinner} 960w, ${MetafightWinner} 1920w`,
                      alt: 'Lineosoft React.js Listing',
                    },
                  ],
                  []
                )}
                width={1431}
                height={806}
              />
            </Suspense>
          </ProjectSectionContent>
        </ProjectSection>


        <ProjectHeader
          title="Seabex"
          description="Seabex is an e-monitoring and smart automation system that helps farmers find the right balance of water consumption to get better quality and quantity production. It includes a control station, sensor station and a gateway. I was responsible for developing Seabex web and mobile app. Using them, farmer can see real time data provided by sensors through the monitoring dashboard. He can create irrigation plans and custom scenarios, for example turn on the irrigation every day at 4PM but stop the water pump if humidity is greater than 80%."
          url="https://www.seabex.com/"
          roles={["ReactJs", "React Native", "Redux", "NodeJs", "GraphQL"]}
        />
        <ProjectSection >
          <ProjectSectionContent>
            <ProjectImage
              raised
              key={themeId}
              srcSet={`${isDark ? Seabex : Seabex
                } 1280w, ${isDark ? Seabex : Seabex
                } 2560w`}
              placeholder={
                isDark
                  ? imageSprLessonBuilderDarkPlaceholder
                  : imageSprLessonBuilderLightPlaceholder
              }
              sizes={`(max-width: ${media.mobile}px) 100vw, (max-width: ${media.tablet}px) 800px, 1000px`}
              alt="The aero lesson builder app dragging an audio component into a screen about plant cells."
            />
          </ProjectSectionContent>
        </ProjectSection>

        <ProjectHeader
          title="Sodebs"
          description="This personal project is a Progressive Web for Sodebs store.
It includes a wheel of fortunes for Sodebs customers, ReactJs dashboard for Sodebs  manager that enables listing and filtering customer details, sending  push notification, customized wysiwyg emails and SMS to the selected customers.
"
          url="https://sodebs.netlify.app/"
          roles={sodebsRoles}
        // roles={roles}
        />
        <ProjectSection  >
          <ProjectSectionContent>
            <ProjectImage
              raised
              key={themeId}
              srcSet={`${isDark ? SodebsWin : SodebsWin
                } 1280w, ${isDark ? SodebsWin : SodebsWin
                } 2560w`}
              placeholder={
                isDark
                  ? imageSprLessonBuilderDarkPlaceholder
                  : imageSprLessonBuilderLightPlaceholder
              }
              sizes={`(max-width: ${media.mobile}px) 100vw, (max-width: ${media.tablet}px) 800px, 1000px`}
              alt="The aero lesson builder app dragging an audio component into a screen about plant cells."
            />
          </ProjectSectionContent>
        </ProjectSection>

        <ProjectHeader
          title="First Portfolio"
          description="Overview of my personal and professional experiences."
          url="https://mehdijarrayaold.netlify.app/"
          roles={["VanillaJs / HTML / Sass", "NodeJs", "UI/UX"]}
        // roles={roles}
        />
        <ProjectSection >
          <ProjectSectionContent>
            <ProjectImage
              raised
              key={themeId}
              srcSet={`${isDark ? OldPortfolio : OldPortfolio
                } 1280w, ${isDark ? OldPortfolio : OldPortfolio
                } 2560w`}
              placeholder={
                isDark
                  ? imageSprLessonBuilderDarkPlaceholder
                  : imageSprLessonBuilderLightPlaceholder
              }
              sizes={`(max-width: ${media.mobile}px) 100vw, (max-width: ${media.tablet}px) 800px, 1000px`}
              alt="The aero lesson builder app dragging an audio component into a screen about plant cells."
            />
          </ProjectSectionContent>
        </ProjectSection>

        <ProjectHeader
          title="Planty"
          description="GatsbyJs e-commerce application cloned for learning purpose."
          url="https://plantcomerce.netlify.app/"
          roles={["GatsbyJs", "ReactJs", "Snipcart"]}
        // roles={roles}
        />
        <ProjectSection >
          <ProjectSectionContent>
            <ProjectImage
              raised
              key={themeId}
              srcSet={`${isDark ? Planty : Planty
                } 1280w, ${isDark ? Planty : Planty
                } 2560w`}
              placeholder={
                isDark
                  ? imageSprLessonBuilderDarkPlaceholder
                  : imageSprLessonBuilderLightPlaceholder
              }
              sizes={`(max-width: ${media.mobile}px) 100vw, (max-width: ${media.tablet}px) 800px, 1000px`}
              alt="The aero lesson builder app dragging an audio component into a screen about plant cells."
            />
            <ProjectTextRow>
              <SegmentedControl
                currentIndex={themes.indexOf(themeId)}
                onChange={handleThemeChange}
              >
                <SegmentedControlOption>Dark theme</SegmentedControlOption>
                <SegmentedControlOption>Light theme</SegmentedControlOption>
              </SegmentedControl>
            </ProjectTextRow>
          </ProjectSectionContent>
        </ProjectSection>
      </ProjectContainer>
      <Footer />
    </Fragment>
  );
};

export default ProjectSPR;
